import * as filterHeaderTypes from '../../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../../common/helpermethods/HelperMethods';


export const PAGE_REFRESH_RATE = 60000;

export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'EOD Date',
        type: filterHeaderTypes.filterTypes.date,
        defaultValue: { from: lastWorkingDay(), to: lastWorkingDay(), today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        fixed: true,
        useValidation: true,
        hideAllButton: true,
        hideToday: true
    },
    {
        id: 'counterparty',
        title: 'Counterparty',
        type: filterHeaderTypes.filterTypes.list,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/counterparties',
        server: true,
        fixed: true,
        customEmptyValue: 'All',
        wide: true,
        includeGroupTitle: false
    },
    {
        id: 'csa',
        title: 'CSA',
        type: filterHeaderTypes.filterTypes.list,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/csas',
        server: true,
        fixed: true,
        includeGroupTitle: false
    },
    {
        id: 'imThresholdCollectUsd',
        title: 'IM Threshold Collect USD',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imThresholdCollectEur',
        title: 'IM Threshold Collect EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imThresholdPostUsd',
        title: 'IM Threshold Post USD',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imThresholdPostEur',
        title: 'IM Threshold Post EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imPledgeUsd',
        title: 'IM Pledge USD',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imPledgeEur',
        title: 'IM Pledge EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imReceiveUsd',
        title: 'IM Receive USD',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    },
    {
        id: 'imReceiveEur',
        title: 'IM Receive EUR',
        type: filterHeaderTypes.filterTypes.number,
        defaultValue: { from: null, to: null },
        availableValues: null,
        availableValuesLocation: null,
        server: false
    }
];

export const defaultFilters = [
    {
        definition: filterDefinitions.find(def => def.id === 'runDate'),
        value: {
            from: lastWorkingDay(),
            to: lastWorkingDay(),
            today: false
        }
    },
    {
        definition: filterDefinitions.find(def => def.id === 'counterparty'),
        value: []
    },
    {
        definition: filterDefinitions.find(def => def.id === 'csa'),
        value: []
    }
];
